<template lang="pug">
  r-form( 
    :loading='busy.form'
    reset-text='restablecer'
    submit-text='guardar'
    title='editar tope de asignacion familiar'
    v-bind='formProps'
    v-model='formData'
    @reset='handleFormReset'
    @submit='handleFormSubmit'
    )
</template>

<script>
//
import { RForm } from '@/components/reusable_components/next'
import HrFamilyAssignmentService from '@/services/api/HumanResource/HrFamilyAssignment'
import catcher from '@/services/translator'
// component
export default {
  name: 'view-family-assignament-create',
  components: {
    RForm,
  },
  data: () => ({
    busy: {
      form: false,
    },
    formData: {},
    formProps: {
      fields: HrFamilyAssignmentService.fields(),
    }
  }),
  methods: {
    async handleFormReset() {
      this.busy.form = true
      this.formData = await HrFamilyAssignmentService.getById(this.$route.params.id)
      this.busy.form = false
    },
    handleFormSubmit() {
      HrFamilyAssignmentService.create(this.formData).then(this.success).catch(this.error)
    },
    success() {
      this.showSuccessSnackbar('Tope de asignacion familiar actualizado exitosamente.')
      this.$router.push({ name: 'family-assignment-list' })
    },
    error(error) {
      this.showErrorSnackbar(catcher(HrFamilyAssignmentService.model(), error.response.data))
    },
  },
  mounted() {
    this.handleFormReset()
  },
}
</script>

